import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { FieldTypes } from '../../utils/constants'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import useConstructionStore from '../../stores/ConstructionStore'
import useUserInvitationsApi from '../../hooks/userInvitations/useUserInvitationsApi'
import useToastContext from '../../hooks/useToastContext'
import { notificationTypes } from '../../contexts/toastContext'
import Form from '../common/Form'

export default function ConstructionMemberForm({ building, closeModal }) {
  const classes = useStyles()
  const [values, setValues] = useState({})

  const create = useConstructionStore((state) => state.createConstructionMember)
  const apiError = useConstructionStore((state) => state.error)
  const cleanState = useConstructionStore((state) => state.cleanState)
  const addToast = useToastContext()

  useEffect(() => {
    if (apiError) {
      addToast(notificationTypes.error, apiError)
      cleanState()
    }
  }, [apiError])

  const [{ userInvitationState }, methods] = useUserInvitationsApi()

  let { id } = useParams()

  const [{ getApartmentsFromBuildingState }, { getApartmentsFromBuilding }] =
    useApartmentsApi()

  useEffect(() => {
    const fetchBuildingData = async () => {
      getApartmentsFromBuilding(building?.id)
      methods.getInvitations({ buildingId: building?.id })
    }
    fetchBuildingData()
  }, [building?.id])

  return (
    <div className={classes.paper}>
      <h2 id="simple-modal-title" className={classes.title}>
        Agregar Persona
      </h2>
      <p>Busqueda de Autorizados/Servicios por de cedula de identidad</p>
      <Form
        values={values}
        setValues={setValues}
        fields={[
          {
            type: FieldTypes.Autocomplete,
            label: 'Cédula',
            hint: 'Seleccione una cédula',
            key: 'ci',
            options: userInvitationState?.invitations?.data || [],
            multiple: false,
            freeSolo: false,
            withMargin: true,
            onChange: (value) => {
              if (value) {
                setValues({
                  ...values,
                  ci: value.ci,
                  name: `${value.firstName} ${value.lastName}`,
                  serviceType: value.serviceType,
                  company: value.company,
                })
              }
            },
            loading: userInvitationState.isLoading,
            disabled: !building,
            getOptionLabel: (option) => {
              const blackListed = !!option.blackListed

              if (option.firstName && option.ci) {
                return `${option.firstName} ${option.lastName} ${option.ci} ${
                  blackListed ? ' - En lista negra' : ''
                }`
              }
              if (option.firstName) {
                return `${option.firstName} ${option.lastName} ${
                  blackListed ? ' - En lista negra' : ''
                }`
              }
              return ''
            },
            renderOption: (option) => {
              const blackListed = !!option.blackListed
              const textStyle = blackListed ? { color: 'red' } : {}

              if (option.firstName && option.ci) {
                return (
                  <span style={textStyle}>
                    {`${option.firstName} ${option.lastName} CI: ${option.ci} ${
                      blackListed ? ' - En lista negra' : ''
                    }`}
                  </span>
                )
              }
              if (option.firstName) {
                return (
                  <span style={textStyle}>
                    {`${option.firstName} ${option.lastName} ${
                      blackListed ? ' - En lista negra' : ''
                    }`}
                  </span>
                )
              }
              return null
            },
          },
          ...(values.company
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Empresa',
                  key: 'company',
                  withMargin: true,
                  disabled: true,
                },
              ]
            : []),
          ...(values.serviceType
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Tipo de servicio',
                  key: 'serviceType',
                  withMargin: true,
                  disabled: true,
                },
              ]
            : []),
          {
            type: FieldTypes.TextField,
            label: 'Cédula',
            hint: 'Ingrese una cédula',
            key: 'ci',
            errorMessage: 'La cédula es requerida',
            numeric: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese una nombre',
            key: 'name',
            errorMessage: 'El nombre es requerido',
            withMargin: true,
            onlyLetters: true,
          },
          {
            type: FieldTypes.Autocomplete,
            label: 'Unidad',
            hint: 'Seleccione un apartamento',
            key: 'apartment',
            options: getApartmentsFromBuildingState.apartments,
            multiple: true,
            freeSolo: false,
            withMargin: true,
            disabled: values.global,
            onChange: (value) => {
              setValues({ ...values, apartment: value?.id })
            },
          },
        ]}
        handleSubmit={() => {
          create(id, values)
          closeModal()
        }}
        handleCancel={() => closeModal()}
      />
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
    width: '100%',
    '& .Mui-error': {
      color: 'white',
    },
    '& .MuiFormHelperText-root': {
      color: '#f44336',
    },
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: '#304968',
    fontSize: '24px !important',
  },
  paper: {
    position: 'absolute',
    width: 600,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
  },
}))
